module.exports = __webpack_public_path__ + "img/linkedin-logo.b4aa38d9.svg";